import { Component, input, InputSignal } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { PathPipe } from 'src/app/rokezzz/locale/pipes/path-pipe';
import { RokezzzLocalStorageService } from 'src/app/rokezzz/local-storage/services/local-storage.service';
import { ButtonComponent } from 'src/app/ui/components/button/button.component';

@Component({
    standalone: true,
    imports: [
        MatIconModule,
        RouterLink,
        ButtonComponent,
        PathPipe
    ],
    selector: '.rokezzz-cookie-popup',
    templateUrl: './cookie-popup.component.html',
    styleUrls: ['./cookie-popup.component.scss']
})
export class RokezzzCookiePopupComponent {
    public readonly privacyPolicyLink: InputSignal<string> = input<string>('regulations');

    private readonly localStorageKey: string = 'cookie-popup';

    public isRequired: boolean;
    public isAccepted: boolean = false;

    public constructor(
        private readonly rokezzzLocalStorageService: RokezzzLocalStorageService,
    ) {
        this.isRequired = this.rokezzzLocalStorageService.getItem(this.localStorageKey) === null;
    }

    public accept(): void {
        this.isAccepted = true;
        this.rokezzzLocalStorageService.setItem(this.localStorageKey, '');
    }
}
